/* eslint-disable no-unused-vars */

import { makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Page } from 'src/components';
import { EventForm } from './components/EventForm';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
    minHeight: '92vh'
  }
}));

export const CreateEventSubscriptionView: FC = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Create Event Subscription">
      <Typography color="textPrimary" gutterBottom variant="h3">
        Create Event Subscription
      </Typography>
      <EventForm isCreateForm />
    </Page>
  );
};
